module.exports = __webpack_public_path__ + "static/qp-f8ebe21454f1aa320a76a1bb7c9a3246.svg";